// test1229
(1229 && 0);
